// @mui
import { Box, Container, Divider, Tab, Tabs } from "@mui/material";
// hooks
import useSettings from "../../hooks/useSettings";
import useTabs from "../../hooks/useTabs";
// components
import { Outlet, useNavigate } from "react-router-dom";
import Page from "../../components/Page";
import { navItems } from "./navItems";
import { Header } from "./Header";
import useAuth from "~src/hooks/useAuth";

export default function CompetitorAnalysisLayout() {
  const { themeStretch } = useSettings();
  const navigate = useNavigate();
  const { user } = useAuth();
  const is_superuser = user?.is_superuser;

  const defaultTab = () => {
    const matchingTab = navItems.find((tab) =>
      location.pathname.includes(tab.path),
    );
    return matchingTab?.value || "map-of-brands";
  };

  const { currentTab, onChangeTab } = useTabs(defaultTab());

  return (
    <Page title={"Competitor Analysis"}>
      <Container maxWidth={themeStretch ? false : "lg"} disableGutters>
        <Box
          sx={{
            mx: 4,
          }}
        >
          <Header />
          <Tabs
            allowScrollButtonsMobile
            variant="scrollable"
            scrollButtons="auto"
            value={currentTab}
            onChange={onChangeTab}
          >
            {navItems.map((tab) => {
              if (
                !is_superuser &&
                (tab.value === "map_of_brands_v2" ||
                  tab.value === "map_of_brands_v3")
              )
                return;
              return (
                <Tab
                  disableRipple
                  data-testid={tab.value}
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  onClick={() => navigate(tab.path)}
                />
              );
            })}
          </Tabs>
          <Divider
            sx={{
              borderColor: "grey.300",
            }}
          />

          <Box sx={{ mb: 3 }} />
          <Outlet />
        </Box>
      </Container>
    </Page>
  );
}
